import yall from 'yall-js';
import Events from "./Components/Core/Events";
import Forms from "./Components/Forms/forms";
import {favoritesInit, favoritesInitItem} from "./Components/Favorites/favorites";
import {compareInit, compareInitItem} from "./Components/Compare/compare";
import IMask from 'imask';
import {initBasketEvents, reInitBasketEvents} from "./Components/basket/basket";
import Locations from './Components/Locations/locations';
import {cartInfoInit} from "./Components/basket/updateCartInfo";
import MmenuLight from "mmenu-light";
import Agent from "./Components/Core/agent";
import {numberFormat, parseHTML} from "./Components/Core/common";
import Swiper, {Navigation, Thumbs} from 'swiper';
import {modal} from "./Components/UI/modal";
import {addToCart} from "./Components/basket/addToCart";
import {notice} from "./Components/UI/notice";
import AuthApi from "./Components/Api/AuthApi";
import {empty} from "./Components/Core/common";

Swiper.use([Navigation, Thumbs]);

const events = new Events();

cartInfoInit(events);

const form = new Forms(events);
let locations = new Locations(events);


document.querySelectorAll('.geo_location').forEach(item => item.addEventListener('click', () => {
    locations.getLocations(item);
}));

favoritesInit('.js_add_favorites');
compareInit('.js_add_compare');
initBasketEvents('.js_add_to_cart', events);

function spoiler(element) {
    element.querySelectorAll('.spoiler').forEach(item => {
        let btn = item.querySelector('.spoiler-btn');
        let block = item.querySelector('.spoiler-block');
        btn.addEventListener('click', () => {
            btn.classList.toggle('active');
            if (!block.classList.contains('active')) {
                item.classList.toggle('active');
                block.classList.add('active');
                block.style.height = 0;
                block.style.height = block.scrollHeight + 'px';
            } else {
                block.style.height = '0px';
                setTimeout(function () {
                    block.classList.remove('active');
                    item.classList.toggle('active');
                }, 350);
            }
        });
    });
}

spoiler(document);

const nitChangeChose = selector => {
    selector.querySelectorAll('[name="chose"]').forEach(item => item.addEventListener('change', () => {
        let choseId = item.dataset.chose;
        let price = parseFloat(item.dataset.price);
        let block = item.closest('.js_item');

        block.querySelectorAll('.js_add_to_cart').forEach(btn => {
            btn.dataset.chose = choseId;
        });

        block.querySelectorAll('.js_price').forEach(el => {
            el.innerHTML = numberFormat(price, '.', ' ');
        });
    }));
};
nitChangeChose(document);

const chosenProduct = (evt) => {
    const item = evt.currentTarget;
    const id = item.dataset.id;
    item.classList.add('preloader');

    Agent.post(`/api/v1/chosen/${id}`)
        .then(e => e.json())
        .then(e => {
            if (e.success) {
                if (e.data.length) {
                    modal(e.data, el => {
                        nitChangeChose(el);
                        el.querySelectorAll('.js_add_to_cart').forEach(e => e.addEventListener('click', addToCart.bind(null, events), false));
                    });
                } else {
                    item.classList.remove('.js_add_chosen');
                    item.removeEventListener('click', chosenProduct);

                    item.classList.add('js_add_to_cart');
                    item.addEventListener('click', addToCart.bind(null, events), false);
                    item.click();
                }
            } else {
                modal(e.message);
            }
        })
        .catch(e => console.log(e))
        .finally(() => {
            item.classList.remove('preloader');
        });
};

function reinitChosen() {
    document.querySelectorAll('.js_add_chosen').forEach(item => {
        item.removeEventListener('click', chosenProduct);
    });
    document.querySelectorAll('.js_add_chosen').forEach(item => {
        item.addEventListener('click', chosenProduct);
    });
}

events.addListener('filter.search', null, () => {
    document.querySelectorAll('.js_add_favorites').forEach(item => favoritesInitItem(item));
    document.querySelectorAll('.js_add_compare').forEach(item => compareInitItem(item));
    reInitBasketEvents('.js_add_to_cart', events);
    reinitChosen();
    form.initModalForm(document);

    document.querySelectorAll('.product-item').forEach(item => {
        if (!item.classList.contains('btn-char-initialized')) {
            item.classList.add('btn-char-initialized');
            let btn_char = item.querySelector('.btn-char');
            if (btn_char) {
                btn_char.addEventListener('click', () => {
                    item.querySelector('.flip-container').classList.toggle('active');
                });
            }
            let flip_close = item.querySelector('.flip-close');
            if (flip_close) {
                flip_close.addEventListener('click', () => {
                    item.querySelector('.flip-container').classList.remove('active');
                });
            }
        }
    });
});

if (document.querySelector('.js_filter_form')) {
    const filter = async () => await import("./Components/Filter/filter");
    filter().then(f => f.init(events));
}

yall({
    observeChanges: true,
    events: {
        load: function (event) {
            if (!event.target.classList.contains("lazy") && event.target.nodeName === "IMG") {
                event.target.classList.add("yall-loaded");
            }
        },
        play: function (event) {
            if (event.target.nodeName === "VIDEO") {
                event.target.nextElementSibling.classList.add("visible");
            }
        }
    }
});

let mobile_menu = document.querySelector("#mobile-menu");
if (mobile_menu) {
    let mobileMenu = new MmenuLight(mobile_menu);
    mobileMenu.navigation({
        title: "Меню",
        theme: "dark"
    });
    let drawerMenu = mobileMenu.offcanvas();
    document.querySelector('a[href="#mobile-menu"]').addEventListener('click', function (evnt) {
        evnt.preventDefault();
        drawerMenu.open();
    });
}


document.querySelectorAll('[type="tel"]').forEach(item => {
    IMask(item, {
        mask: '{8} (000) 000-00-00'
    });
});

const loadViewed = document.querySelector('.viewed');
if (loadViewed) {
    let observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                if (!loadViewed.querySelector('div')) {
                    Agent.post(`/api/v1/viewed`)
                        .then(e => e.json())
                        .then(e => {
                            if (e.success) {
                                loadViewed.append(parseHTML(e.data));
                                events.dispatch('filter.search');

                                loadViewed.querySelectorAll('.slider-5').forEach(item => {
                                    let currentCategory = item.dataset.category;
                                    let currentNavigation = document.querySelector(`.slider-navigation-5[data-category="${currentCategory}"]`);
                                    let navigation = {};
                                    if (currentNavigation) {
                                        let next = currentNavigation.querySelector('.slider-next');
                                        let prev = currentNavigation.querySelector('.slider-prev');
                                        navigation = {
                                            nextEl: next,
                                            prevEl: prev,
                                        };
                                    }
                                    new Swiper(item, {
                                        spaceBetween: 10,
                                        slidesPerView: 1,
                                        navigation: navigation,
                                        watchSlidesVisibility: true,
                                        slideActiveClass: "active",
                                        breakpoints: {
                                            540: {
                                                slidesPerView: 2,
                                            },
                                            1120: {
                                                slidesPerView: 3,
                                            },
                                            1480: {
                                                slidesPerView: 4,
                                            },
                                            1660: {
                                                slidesPerView: 5,
                                            },
                                        }
                                    });
                                });
                            }
                        })
                        .catch(e => console.log(e))
                        .finally(() => {
                            obs.unobserve(entry.target);
                        });
                }
            }
        });
    });

    observer.observe(loadViewed);
}

reinitChosen();

document.querySelectorAll('.js_open_autorize_form').forEach(item => item.addEventListener('click', () => {
    const options = {
        header: function () {
            return ``;
        },
        message: `<div class="modal-head">
                        <div class="fs-lg-32 fs-md-28 fs-24 fw-black mb-20 text-second">Вход в личный кабинет</div>
                        <p class="lh-base mb-0">Укажите номер телефона, на который придет SMS-код и нажмите “Получить код”. Впишите SMS-код в поле ввода и нажмите “Войти”.</p>
                        <button class="btn-close position-absolute top-0 end-0 rounded-circle p-5 d-flex border-0 mt-sm-20 mt-10 me-sm-20 me-10" type="button" data-bs-dismiss="modal" aria-label="Close"><i class="close fs-20 text-second"></i></button>
                    </div>
                    <form class="modal-form" name='authorization' method='post'>
                         <label class="input-block d-flex flex-column flex-sm-row rounded-pill position-relative">
                            <input class="input-phone main-input rounded-pill px-30 py-20 w-100 mb-10 mb-sm-0" 
                                type="tel" placeholder="Номер телефона" name="phone" required
                            >
                            <button class="rounded-pill d-flex align-items-center px-sm-20 py-sm-15 px-30 py-20 border-2 flex-grow-1 fs-14 me-sm-5 btn btn-outline-main js_recover_password">                  
                                <span class="flex-grow-1 fw-bold">Получить SMS-код</span>
                            </button>
                        </label>
                        <label class="input-block d-flex flex-column flex-sm-row rounded-pill position-relative">
                            <input class="main-input rounded-pill px-30 py-20 w-100 mb-10 mb-sm-0" 
                                type="password" placeholder="SMS-код" name="password"
                            >
                            <button class="js_auth_button rounded-pill d-flex align-items-center px-sm-20 py-sm-15 px-30 py-20 border border-2 border-main btn btn-main flex-grow-1 fs-14 me-sm-5">                  
                                <span class="flex-grow-1 fw-bold text-white">Войти</span>
                            </button>
                        </label>
                        <div class="message w-100 d-flex justify-content-center">
                            <span class="fw-regular fs-14 text-danger js_message_label"></span>
                            <span class="fw-regular fs-14 text-danger js_message_sms_label d-none"> </span>
                        </div>
                    </form>`,
        showEvent: function (to) {

            let inputPhone = to.querySelector('input[name="phone"]');
            let inputPassword = to.querySelector('input[name="password"]');
            let js_recover_password = to.querySelector('.js_recover_password');

            let js_message_label = to.querySelector('.js_message_label');
            let js_message_sms_label = to.querySelector('.js_message_sms_label');
            let form = to.querySelector('form');
            let js_auth_button = to.querySelector('.js_auth_button');

            const authorization = function () {
                js_message_label.innerHTML = '';

                let userName = inputPhone.value.trim().replace(/[^0-9]/g, '');
                let password = inputPassword.value.trim();

                if (empty(userName) || empty(password)) {
                    notice("Необходимо заполнить<br> обязательные поля.");
                    return;
                }

                AuthApi.authorization(userName, password)
                    .then(response => response.json())
                    .then(response => {
                        if (response.success) {
                            if (response.url) {
                                document.location.href = response.url;
                            } else {
                                document.location.reload();
                            }
                        } else {
                            js_message_label.innerHTML = response.message;
                        }
                    })
                    .catch(() => {
                        notice("Не удалось сменить пароль.<br> Попробуйте позже <br>или<br> обратитесь к администратору.");
                    });
            };

            const timer = (timerPeriod, start, tick, finish) => {
                let counter = timerPeriod || 1;
                if (typeof start === 'function') {
                    start();
                }
                if (typeof tick === 'function') {
                    tick(counter);
                }
                let smsTimer = setInterval(function () {
                    counter--;
                    if (typeof tick === 'function') {
                        tick(counter);
                    }
                    if (counter === 0) {
                        counter = timerPeriod;
                        clearInterval(smsTimer);
                        if (typeof finish === 'function') {
                            finish();
                        }
                    }
                }, 1000);
            };

            const smsTimer = seconds => {
                timer(parseInt(seconds), function () {
                    js_recover_password.disabled = true;
                    js_message_sms_label.classList.remove('d-none');
                }, function (secondsLeft) {
                    js_message_sms_label.innerHTML = `Пароль был выслан на указанный номер. <br>Следующая отправка СМС возможна через <b>${secondsLeft}</b> секунд`;
                }, function () {
                    js_recover_password.disabled = false;
                    js_message_sms_label.classList.add('d-none');
                });
            };

            const recover_password = function () {

                let phone = inputPhone.value.trim().replace(/[^0-9]/g, '');
                if (empty(phone)) {
                    notice("Необходимо заполнить<br> обязательные поля.");
                } else {
                    js_recover_password.classList.add('preloader');
                    AuthApi.recoverPassword(phone)
                        .then(response => response.json())
                        .then(response => {
                            if (response.message && !response.seconds) {
                                js_message_label.innerHTML = response.message;
                            }
                            if (response.seconds) {
                                smsTimer(response.seconds);
                            }
                        })
                        .catch(() => {
                            notice("Не удалось отправить пароль.<br> Попробуйте позже<br> или<br> обратитесь к администратору.");
                        })
                        .finally(() => {
                            js_recover_password.classList.remove('preloader');
                        });
                }
            };


            inputPhone.addEventListener('input', () => {
                js_message_label.innerHTML = '';
            });

            js_auth_button.addEventListener('click', () => {
                js_message_label.innerHTML = '';

                if (inputPassword.value.trim().length > 3) {
                    authorization();
                }
            });

            js_recover_password.addEventListener('click', () => {
                js_message_label.innerHTML = '';
                recover_password();
            });

            form.addEventListener('submit', event => {
                event.stopPropagation();
                event.preventDefault();
            });
        }
    };

    modal(options);
}));

const menuBtn = document.querySelector('.header-catalog-btn');
if (menuBtn) {

    const menuBlock = document.querySelector('.main-menu');
    const header = document.querySelector('header');

    menuBtn.addEventListener('click', () => {
        let rect = header.getBoundingClientRect();            
        let scrollTop = window.scrollY;
        let topH = header.clientHeight + (rect.top + scrollTop) + 10;
        if (menuBlock.querySelector('div')) {                        
            menuBlock.style.top = topH + 'px';     
            menuBtn.classList.toggle('active');
            menuBlock.classList.toggle('active');
        } else {
            menuBtn.classList.add('preloader');
            Agent.post(`/api/v1/menu`)
                .then(e => e.json())
                .then(e => {
                    menuBlock.innerHTML = e.data;
                    menuBlock.style.top = topH + 'px';
                    spoiler(menuBlock);

                    document.addEventListener('click', e => {
                        if (menuBlock.classList.contains('active') && e.target === menuBlock) {
                            menuBlock.classList.remove('active');
                            menuBtn.classList.remove('active');
                        }
                    });

                })
                .catch(e => console.log(e))
                .finally(() => {
                    menuBtn.classList.remove('preloader');
                    menuBtn.classList.toggle('active');
                    menuBlock.classList.toggle('active');
                });
        }
    });
}

function closeSel(elm) {
    document.querySelectorAll('.custom-select').forEach(item => {
        if (item !== elm) {
            item.querySelector('.custom-select-value').classList.remove('active');
            item.querySelector('.custom-select-block').classList.remove('active');
        }
    });
}

document.querySelectorAll('.custom-select').forEach(select => {
    let sndSelect = select.querySelector('select');
    let selectValue = document.createElement('div');
    let selectResult = document.createElement('span');
    let selectBlock = document.createElement('div');
    let selectOption;
    selectValue.setAttribute('class', 'custom-select-value main-input');
    selectResult.setAttribute('class', 'custom-select-result');
    selectBlock.setAttribute('class', 'custom-select-block');
    selectResult.innerHTML = sndSelect.options[sndSelect.selectedIndex].innerHTML;
    selectValue.appendChild(selectResult);
    selectValue.appendChild(document.createElement('i')).setAttribute('class', 'down-arrow fs-30 text-second');
    select.appendChild(selectValue);
    for (let i = 1; i < sndSelect.length; i++) {
        selectOption = document.createElement('div');
        selectOption.innerHTML = sndSelect.options[i].innerHTML;
        selectOption.addEventListener('click', function () {
            let parentSelect = this.parentNode.parentNode.querySelector('select');
            let parentSibling = this.parentNode.previousSibling.querySelector('.custom-select-result');
            for (let j = 0; j < parentSelect.length; j++) {
                if (parentSelect.options[j].innerHTML === this.innerHTML) {
                    parentSelect.selectedIndex = j;
                    parentSibling.innerHTML = this.innerHTML;
                    let sameAsSlt = this.parentNode.querySelectorAll(".same-as-selected");
                    sameAsSlt.forEach(items => {
                        items.classList.remove('same-as-selected');
                    });
                    this.classList.add('same-as-selected');
                }
            }
            parentSibling.click();
        });
        selectBlock.appendChild(selectOption);
    }
    select.appendChild(selectBlock);
    selectValue.addEventListener('click', function (e) {
        e.stopPropagation();
        closeSel(this.closest('.custom-select'));
        this.nextSibling.classList.toggle("active");
        this.classList.toggle("active");
    });
});

document.addEventListener('click', function (e) {
    if (!e.target.closest('.custom-select')) {
        document.querySelectorAll('.custom-select').forEach(item => {
            item.querySelector('.custom-select-value').classList.remove('active');
            item.querySelector('.custom-select-block').classList.remove('active');
        });
    }
});

export default events;